import CourtRecordVerification from '@/features/Application/court-record-verification'
import PotentialRisks from '@/features/Application/potential-risks'
import Bankruptcies from '@/features/Application/bankruptcies'
import CollectionsRecord from '@/features/Application/collections-record'
import Empty from './empty'
import AnalyzingText from './analyzing-text'

const View = ({ data, isLocked, application, isAnalyzing, isLoading, standalone }) => {
  const showEmpty = application?.trust_score?.status !== 'active' && !isLocked && !standalone

  return (
    <>
      <CourtRecordVerification
        data={data}
        application={application}
        isLocked={isLocked}
        isLoading={isLoading}
        standalone={standalone}
      />
      <PotentialRisks
        data={data}
        application={application}
        isLocked={isLocked}
        isLoading={isLoading}
        standalone={standalone}
      />
      <Bankruptcies
        data={data?.bankruptcy}
        application={application}
        isLocked={isLocked}
        isLoading={isLoading}
        standalone={standalone}
      />
      <CollectionsRecord
        data={data?.collection}
        application={application}
        isLocked={isLocked}
        isLoading={isLoading}
        standalone={standalone}
      />
      {showEmpty && <Empty isAnalyzing={isAnalyzing} isLocked={isLocked} isLoading={isLoading} />}
      {isAnalyzing && <AnalyzingText isLocked={isLocked} />}
    </>
  )
}

export default View
